const o=840;export{o as CONTENT_MAX_WIDTH};
//# sourceMappingURL=constants.js.map
